import { Link } from "react-router-dom";
import { collections } from "@/mocks/home";

export default function FeaturedCollections() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-14">
      <div className="mb-6 md:mb-8">
        <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-1 h-6 md:h-7 rounded-full bg-accent-500 inline-block"></span>
          推荐专题合集
        </h2>
        <p className="mt-2 text-xs md:text-sm text-foreground-500">
          围绕“邻居的妻子”及热门题材整理的观影合集，帮你一次看个够
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
        {collections.map((c) => (
          <Link
            key={c.id}
            to={c.id === "neighbor-wife" ? `/detail/${c.id}` : `/category?genre=${c.genre}`}
            className="group relative block rounded-lg overflow-hidden h-52 md:h-64 cursor-pointer"
          >
            <img
              src={c.cover}
              alt={`${c.title} 专题合集`}
              title={`${c.title} - 邻居的妻子影视大全`}
              className="w-full h-full object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
              <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500 text-primary-950 text-[11px] font-bold mb-2">
                {c.genre}合集
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">{c.title}</h3>
              <p className="mt-1 text-xs md:text-sm text-background-200/90">{c.subtitle}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-accent-300 font-medium">
                进入合集
                <i className="ri-arrow-right-s-line text-lg transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}